// client: rise
// env: staging
// branch: main

export const environment = {
  // client name
  client: 'staging',
  // is this a production environment?
  production: true,
  // api url
  apiUrl: 'https://api.rise-staging.ffi-ventures.com',
  // !UNUSED? list of support PDF files in the form of { name: string, path: string }[]
  supportPdfs: [],
  reportsShowKamReports: true,
  // enable cache
  enableCache: false
};
